import { http } from './config';

const RESPONSAVEL_PATH = 'responsavel-estado';

export default {
  listar: object => {
    let params = `page=${object.page ? object.page : 1}`;
    if (object.somenteAtivos) {
      params += '&somenteAtivos=true';
    }
    if (object.estado) {
      params += `&estado=${object.estado}`;
    }
    return http.get(`${RESPONSAVEL_PATH}?${params}`);
  },

  salvar: responsavel => http.post(RESPONSAVEL_PATH, responsavel),

  atualizar: responsavel =>
    http.post(`${RESPONSAVEL_PATH}/${responsavel._id}`, responsavel),

  deletar: responsavel => http.delete(`${RESPONSAVEL_PATH}/${responsavel._id}`),

  trocarAtivo: _id => http.post(`${RESPONSAVEL_PATH}/${_id}/trocar-ativo`)
};
